var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mychart",style:({ widith: '100%', height: _vm.computedHeight })})
}
var staticRenderFns = []

export { render, staticRenderFns }